import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { ScheduledRidesQueryInput } from '@/models/scheduledRide';

export const fetchScheduledRideRecords = async ({
  pagination,
  phoneNumber,
  scheduledRideId,
  isActive,
  isFinished,
  isCanceled,
  isSingle,
  isRepeated,
  isAllSpecialRequestAndPharmacy,
}: ScheduledRidesQueryInput) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      phoneNumber,
      scheduledRideId,
      isActive,
      isFinished,
      isCanceled,
      isSingle,
      isRepeated,
      isAllSpecialRequestAndPharmacy,
      pagination,
    },
    query: graphql(`
      query ScheduledRides(
        $pagination: PaginationInputType
        $phoneNumber: String
        $scheduledRideId: Float
        $isActive: Boolean
        $isFinished: Boolean
        $isCanceled: Boolean
        $isSingle: Boolean
        $isRepeated: Boolean
        $isAllSpecialRequestAndPharmacy: Boolean
      ) {
        scheduledRides(
          pagination: $pagination
          phoneNumber: $phoneNumber
          scheduledRideId: $scheduledRideId
          isActive: $isActive
          isFinished: $isFinished
          isCanceled: $isCanceled
          isSingle: $isSingle
          isRepeated: $isRepeated
          isAllSpecialRequestAndPharmacy: $isAllSpecialRequestAndPharmacy
        ) {
          count
          rows {
            id
            completedAt
            canceledAt
            updatedAt
            emailedReminderAt
            calledReminderAt
            callerId
            firstPickup
            lastRideAt
            executedAt
            firstName
            lastName
            riderPhone
            rideName
            rideType
            rideMultiple
            pickupTime
            pickupDate
            skipScheduledRideDates
            timeZone
            endAfterXTimes
            endOn
            day0
            day1
            day2
            day3
            day4
            day5
            day6
            repeatEveryXWeek
            streetAddress1
            city1
            state1
            zip1
            lat1
            long1
            streetAddress2
            city2
            state2
            zip2
            lat2
            long2
            noteToDriver
            cancellationReason
            callAttempts
            callToConfirmSurge
            partnerId
            customerCostOverride
            createdAt
            nextPickupTimeString
            createdAtWebsite
            customRiderName
            destinations
            minutesToAutoRetryRequest
            isGoGoMedical
            isDoNotApplySubsidy
            isDoNotApplyExpiringCredits
            minutesBeforeCustomReminder
            minutesAfterCreationCustomReminder
            overrideBigCar
            overrideSmallCar
            overrideBannedCar
            overrideBadDriver
            gender
            levelOfService
            hasOwnWheelchair
            specialInstructions
            numberOfCompanions
            appointmentType
            appointmentTime
            returnTime
            locationName1
            stairStepsForPU
            locationName2
            stairStepsForDO
            dropOffPhoneNumber
            callerPhoneNumber
            notesForLP
            serviceType
            callerName
            confirmedAt
            isVendorRide
            requestId
            scheduledAppointmentDate
            scheduledAppointmentTime
            scheduledAppointmentBufferMinutes
          }
        }
      }
    `),
  });

  return response.data.scheduledRides;
};
